import {IEarnMore} from 'user-reducer/src/user-types';
import formatPrice from '../../../../utils/formatPrice';

export const getEarnMoreData = ({
  percentage = 1,
  min_amount = '1 Lakh',
  max_incentive = 5000,
  tier,
  icon_url,
}: IEarnMore): any => {
  const minRecharge = formatPrice(min_amount);
  const maxIncentive = formatPrice(max_incentive);
  const monthArray = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const d = new Date();
  let month = monthArray[d.getMonth()];
  let year = d.getFullYear();
  const heading = !tier.toLowerCase().startsWith('hero')
    ? 'Recharge More To Earn More!'
    : `${tier} Benefit for ${month}, ${year}`;
  return {
    icon: icon_url,
    heading: heading,
    subHeading: `Get ${percentage}% instant unlimited cashback on recharge of ₹1,00,000 or more`,
    listData: [
      {
        id: '1',
        labelText: `Enter a recharge amount of <span>${minRecharge}</span> or more `,
      },
      {
        id: '2',
        labelText:
          'Complete the payment through your preferred mode (Credit Card/ Debit Card/ UPI/ NEFT) ',
      },
      {
        id: '3',
        labelText: `Get an instant unlimited cashback of flat <span> ${percentage}% on your recharge amount</span> credited to your My Cash wallet `,
      },
    ],

    // cta: "Know More",

    // knowMoreData: [

    //   'Instant credit - Cashback to be credited instantly to your wallet ',

    //   `Lucrative incentive - Incentive up to ${maxIncentive} `,

    //   'No restrictions – Validity of upto a year and no restriction on usage ',

    //   'Additional savings – Use on flight and hotel bookings to save more ',

    // ]
  };
};

export const getEarnMoreDataAed = ({
  percentage = 1,
  min_amount = '1',
  max_incentive = 5000,
  tier,
  icon_url,
}: IEarnMore): any => {
  const minRecharge = formatPrice(min_amount, 'AED');
  const maxIncentive = formatPrice(max_incentive, 'AED');
  const monthArray = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const d = new Date();
  let month = monthArray[d.getMonth()];
  let year = d.getFullYear();
  const heading = !tier.toLowerCase().startsWith('hero')
    ? 'Recharge More To Earn More!'
    : `${tier} Benefit for ${month}, ${year}`;
  return {
    icon: icon_url,
    heading: heading,
    subHeading: `Get ${percentage}% instant unlimited cashback on wallet recharge`,
    listData: [
      {
        id: '1',
        labelText: `Enter a recharge amount `,
      },
      {
        id: '2',
        labelText: 'Complete the payment through eligible modes',
      },
      {
        id: '3',
        labelText: `Get an instant unlimited cashback of flat <span> ${percentage}% on your recharge amount</span> credited to your My Cash wallet `,
      },
    ],

    // cta: "Know More",

    // knowMoreData: [

    //   'Instant credit - Cashback to be credited instantly to your wallet ',

    //   `Lucrative incentive - Incentive up to ${maxIncentive} `,

    //   'No restrictions – Validity of upto a year and no restriction on usage ',

    //   'Additional savings – Use on flight and hotel bookings to save more ',

    // ]
  };
};
